export const freeResources = {
  fiveLies: {
    title: "5 Lies Survivors Believe",
    subtitle: "And the Truth That Sets You Free",
    introduction: `Dear Sister,

If you've experienced sexual abuse, chances are you've believed some lies about yourself. These lies weren't planted by you—they were seeds of deception sown by trauma, shame, and the enemy of your soul.

Today, we're going to expose five of the most common lies survivors believe and replace them with God's liberating truth.`,
    lies: [
      {
        lie: "It was my fault.",
        truth: "What happened to you was NOT your fault. Regardless of circumstances, the responsibility lies entirely with the person who chose to harm you.",
        scripture: "The Lord is close to the brokenhearted and saves those who are crushed in spirit.",
        reference: "Psalm 34:18",
        reflection: "No matter what you were wearing, where you were, or what you did—you did not cause this. A child is never responsible for an adult's sin. A victim is never responsible for an abuser's choices."
      },
      {
        lie: "I am damaged goods.",
        truth: "You are God's masterpiece, created for a purpose. What happened TO you does not define WHO you are.",
        scripture: "For we are God's handiwork, created in Christ Jesus to do good works, which God prepared in advance for us to do.",
        reference: "Ephesians 2:10",
        reflection: "Your worth was established by your Creator before you were born. No person and no experience can diminish the value God placed on you."
      },
      {
        lie: "No one will ever love me if they knew.",
        truth: "You are fully known and fully loved by God. And there are safe people who will love you unconditionally.",
        scripture: "See what great love the Father has lavished on us, that we should be called children of God!",
        reference: "1 John 3:1",
        reflection: "Shame tells us to hide. But healing happens in the light of safe relationships. You are worthy of love—the real, unconditional kind."
      },
      {
        lie: "I should be over this by now.",
        truth: "Healing is not a race. There is no timeline for processing trauma. Give yourself grace.",
        scripture: "He has made everything beautiful in its time.",
        reference: "Ecclesiastes 3:11",
        reflection: "Your healing journey is unique. Comparing yourself to others or arbitrary timelines only adds unnecessary burden. Trust the process."
      },
      {
        lie: "God can't use someone like me.",
        truth: "God specializes in using broken vessels for His glory. Your story can bring hope to others.",
        scripture: "But we have this treasure in jars of clay to show that this all-surpassing power is from God and not from us.",
        reference: "2 Corinthians 4:7",
        reflection: "Some of the most powerful ministers are those who have walked through darkness and found the Light. Your pain has purpose."
      }
    ],
    closing: `Remember: Believing lies keeps us in bondage. Embracing truth sets us free.

You are not what happened to you.
You are who God says you are.

With love and prayers for your healing journey,
Your Sister in Christ`,
    cta: "Ready to go deeper? The full Breakthrough guide walks you through 6 transformative chapters of healing, with interactive journaling, prayers, and affirmations."
  }
};
